import { render, staticRenderFns } from "./VueBootstrapTypeaheadList.vue?vue&type=template&id=04588a74&"
import script from "./VueBootstrapTypeaheadList.vue?vue&type=script&lang=js&"
export * from "./VueBootstrapTypeaheadList.vue?vue&type=script&lang=js&"
import style0 from "./VueBootstrapTypeaheadList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports